<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="balance_transactions"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
// import { podStatus, paymentChinese } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      columns: [
        {
          title: 'ID',
          width: 60,
          align: 'center',
          key: 'id'
        },
        {
          title: i18n.t('pages_balance_transaction_index_172'),
          align: 'center',
          key: 'transaction_type',
          render: (h, params) => {
            return h('span', params.row.transaction_type === 'consumption' ? '支出' : i18n.t('pages_balance_transaction_index_173'))
          }
        },
        // {
        //   title: '操作类型',
        //   align: 'center',
        //   key: 'consumer_type',
        //   render: (h, params) => {
        //     return h('span', params.row.consumer_type === 'SmsCharge' ? '短信充值' : params.row.consumer_type)
        //   }
        // },
        {
          title: i18n.t('pages_balance_transaction_index_174'),
          align: 'center',
          key: 'desc'
        },
        {
          title: i18n.t('pages_balance_transaction_index_175'),
          align: 'center',
          key: 'amount',
          render: (h, params) => {
            return h('span', {
              style: {
                color: params.row.transaction_type === 'consumption' ? 'red' : 'green'
              }
            }, `${params.row.transaction_type === 'consumption' ? '-' : '+'}${params.row.amount}`)
          }
        },
        {
          title: i18n.t('pages_balance_transaction_index_176'),
          align: 'center',
          key: 'state',
          render: (h, params) => {
            return h('span', params.row.state === 'init' ? '进行中' : i18n.t('libs_table_render_65'))
          }
        },
        // {
        //   title: '操作前余额',
        //   align: 'center',
        //   key: 'old_balance'
        // },
        // {
        //   title: '操作后余额',
        //   align: 'center',
        //   key: 'new_balance'
        // },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at',
          width: 200,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.index()
  },
  computed: {
    ...mapGetters('balance_transaction', ['balance_transactions', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('balance_transaction', ['index']),
    ...mapMutations('balance_transaction', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page })
      this.index()
    }
  }
}
</script>
